import { Document } from '@roc/feature-types';
import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { AppraisalDetails, QuestionnairePrompt } from './appraisalDetails';
import { AppraisalDetailsHeader } from './appraisalDetailsHeader';
import { Box } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';

const useStyles = makeStyles((theme: Theme) => ({
  dialog: {
    ['& .MuiDialog-paper']: {
      backgroundColor: theme.palette.background.default,
      minHeight: '400px',
    },
  },
  container: {
    paddingBottom: '16px',
  },
}));

type Props = {
  open?: boolean;
  onClose?: () => void;
  loanId: number;
  lenderId?: number;
  loanPropertyValuationId?: number;
};

export const AppraisalDetailsDialogV2 = observer(
  ({ open, onClose, loanId, loanPropertyValuationId, lenderId }: Props) => {
    const classes = useStyles();
    const { appraisalDetailsV2Store } = useStore();
    const { showQuestionnaire } = appraisalDetailsV2Store;

    useEffect(() => {
      if (open) {
        appraisalDetailsV2Store.reset();
        appraisalDetailsV2Store.fetchAppraisalDetails(loanId, loanPropertyValuationId);
        appraisalDetailsV2Store.fetchResetCapability(loanId);
        appraisalDetailsV2Store.fetchFeeReconciliation(loanId);
      }
    }, [open]);

    const dialogContent = (
      <Box flex={1}>
        {/* Header Section */}
        <AppraisalDetailsHeader store={appraisalDetailsV2Store} />
        <Box className={classes.container}>
          {showQuestionnaire ? (
            <QuestionnairePrompt store={appraisalDetailsV2Store} loanId={loanId} />
          ) : (
            <AppraisalDetails store={appraisalDetailsV2Store} loanId={loanId} lenderId={lenderId} />
          )}
        </Box>
      </Box>
    );

    return (
      <StandardDialog
        open={open}
        title="Valuation Details"
        maxWidth="lg"
        handleClose={onClose}
        dialogContent={dialogContent}
        className={classes.dialog}
        removeContentBox
      />
    );
  }
);
